import { FormaExpandedTooltip } from '@/components/UI/FormaExpandedTooltip/FormaExpandedTooltip';
import styles from './styles.module.scss';
import { SunlightScoreBreakdown } from '@/services/score/sunlight';
import { SunlightRecommendation } from './SunlightRecommendation';

interface SunlightBreakdownProps {
	id: string;
	scoreData: SunlightScoreBreakdown;
}

interface SunlightSection {
	label: string;
	score: number;
	maxScore: number;
}

export const SunlightBreakdown = ({ id, scoreData }: SunlightBreakdownProps) => {
	const sections: SunlightSection[] = [
		{ label: 'Winter', score: scoreData.winterScore, maxScore: 30 },
		{ label: 'Summer', score: scoreData.summerScore, maxScore: 25 },
		{ label: 'Spring/Fall', score: scoreData.springFallScore, maxScore: 25 },
		{ label: 'Consistency', score: scoreData.consistencyScore, maxScore: 10 },
		{ label: 'Quality', score: scoreData.qualityScore, maxScore: 10 },
	];

	return (
		<FormaExpandedTooltip
			loadingduration={500}
			position="left"
			text="Daylight Breakdown"
			targetId={id}
		>
			<div className={styles.scoreSummary}>
				<div className={styles.summaryTitle}>
					<strong>Total Score: {scoreData.totalScore.toFixed(1)}</strong>
					<span>Avg: {scoreData.averageHours.toFixed(1)}h/day</span>
				</div>

				<div className={styles.simpleRecommendation}>
					<SunlightRecommendation scoreData={scoreData} />
				</div>

				<div className={styles.simpleTable}>
					{sections.map((section) => {
						const percentage = (section.score / section.maxScore) * 100;
						const color =
							percentage < 40
								? '#ef4444'
								: percentage < 70
									? '#f59e0b'
									: '#10b981';

						return (
							<div key={section.label} className={styles.tableRow}>
								<div className={styles.rowInfo}>
									<span className={styles.rowLabel}>{section.label}</span>
									<span className={styles.rowMeta}>
										{section.score.toFixed(1)} / {section.maxScore}
									</span>
								</div>
								<div className={styles.rowBarWrapper}>
									<div className={styles.simpleBarBg}>
										<div
											className={styles.simpleBarFill}
											style={{
												width: `${percentage}%`,
												backgroundColor: color,
											}}
										/>
									</div>
									<span className={styles.rowScore}>{section.score.toFixed(1)}</span>
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</FormaExpandedTooltip>
	);
};
